"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdjustmentDataCache = void 0;
var _commonUtils = require("@abacus/common-utils");
class AdjustmentDataCache {
  constructor(config) {
    this.accountContractIds = new Map();
    this.accountIds = new _commonUtils.FIFOSet(config?.capacity);
    this.accountPaymentEntityIds = new _commonUtils.FIFOMap(config?.capacity);
    this.accountUpcs = new _commonUtils.FIFOMap(config?.capacity);
    this.adjustmentTypes = new Set();
    this.paymentEntityCloseBalanceStatuses = new Map();
    this.statementPeriods = new Map();
  }
}
exports.AdjustmentDataCache = AdjustmentDataCache;